// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"394":"7e8baf5ce355ba29ae93","585":"18b51d838bb36fe5209f","792":"16e8d238b12199d25128","972":"08655b9a812b0a6a49bb"}[chunkId] + ".js";
};